module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/product-images/fr-product-02-76104b5d2ff99e2cd0436579497a3bd0.jpg";